import React from 'react';
import './Slider.scss';

interface SliderProps {
  min: number;
  max: number;
  step?: number;
  value: number;
  onChange: (value: number) => void;
  labels?: string[];
  disabled?: boolean;
}

const Slider: React.FC<SliderProps> = ({ min, max, step = 1, value, onChange, labels, disabled }) => {
  return (
    <div className="slider-widget" style={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch', gap: 4 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, margin: '12px 0' }}>
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={e => onChange(Number(e.target.value))}
          style={{ flex: 1 }}
          disabled={disabled}
        />
      </div>
      {labels && labels[value - min] && (
        <span style={{ minWidth: 120, textAlign: 'center', marginTop: 4 }}>{labels[value - min]}</span>
      )}
    </div>
  );
};

export default Slider;
